import { PromoBanner } from "./PromoBanner";
import type { ReactNode } from "react";
import { Disclaimer } from "./Disclaimer";
import { Footer } from "./Footer";
import { Header } from "./Header";

export function Layout({ children }: { children: ReactNode }) {
  return (
    <div className="site">
      <PromoBanner />
      <Header />
      <main className="site-main" id="main">
        {children}
      </main>
      <Disclaimer />
      <Footer />
    </div>
  );
}
